// extracted by mini-css-extract-plugin
module.exports = {"NewIdeaForm":"NewIdeaForm_NewIdeaForm__gMquW"};